import axios from "axios";
import { config } from "../../utils/axiosconfig";
import { base_url } from "../../utils/baseUrl";

const getToken = () => {
  const user = localStorage.getItem("user")
    ? JSON.parse(localStorage.getItem("user"))
    : null;
  return user?.data?.token || null;
};

const getAuthHeaders = () => {
  const token = getToken();
  return {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
};

// const getAllRates = async () => {
//   const response = await axios.get(`${base_url}rate/latest-rates`);

//   return response.data;
// };

const getAllRates = async () => {
  try {
    const response = await axios.get(`${base_url}rate/latest-rates`, getAuthHeaders());
    console.log("Fetched Data:", response.data); // Debugging line
    return response.data;
  } catch (error) {
    console.error("API Fetch Error:", error.response?.data || error.message);
    throw error;
  }
};


const deleteEnquiry = async (id) => {
  const response = await axios.delete(`${base_url}enquiry/${id}`, getAuthHeaders());
  return response.data;
};

const getEnquiry = async (id) => {
  const response = await axios.get(`${base_url}contactus/get/${id}`, getAuthHeaders());
  return response.data;
};

// const updateRates = async (rates) => {
//   try {
//     const response = await axios.put(
//       `${base_url}rate/update-rates`,
//       {
//         gold_rate: rates.gold_rate || undefined,
//         silver_rate: rates.silver_rate || undefined,
//         platinum_rate: rates.platinum_rate || undefined,
//       },
//       config
//     );
//     return response.data;
//   } catch (error) {
//     console.error("Update Rates Error:", error.response?.data || error.message);
//     throw error;
//   }
// };

const updateRates = async (rates) => {
  const response = await axios.put(`${base_url}rate/update-rates`, rates, getAuthHeaders());
  return response.data;
};

// const updateRates = async (rates) => {
//   const response = await axios.put(
//     `${base_url}rate/update-rates`,
//     {
//       gold_rate: Number(rates.goldRate) || 0,
//       silver_rate: Number(rates.silverRate) || 0,
//       platinum_rate: Number(rates.platinumRate) || 0,
//     },
//     config
//   );
//   return response.data;
// };


const dailymetalrateService = {
  getAllRates,
  deleteEnquiry,
  getEnquiry,
  updateRates,
};

export default dailymetalrateService;
